<template>
    <Head title="Welcome"/>
    <div class="bg-gray-200 h-screen flex items-center justify-center">
        <div class="bg-white p-8 rounded shadow-md max-w-md w-full">
            <h2 class="text-2xl font-bold mb-4">Pendaftaran Ditutup</h2>
            <p class="text-gray-700 mb-6">Maaf, pendaftaran penyedia sudah ditutup. Terima kasih atas partisipasinya.</p>
            <a href="/" class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition duration-300">Kembali
                ke Beranda</a>
        </div>
    </div>

</template>


<script>
import {defineComponent} from 'vue'
import {Head, Link} from '@inertiajs/inertia-vue3';

export default defineComponent({
    components: {
        Head,
        Link,
    },

})
</script>
